import React from 'react';

import './SellFundMinMax.scss';

import { SELL_FUND_MIN_MAX_MODAL } from '../../../redux/modules/modals/modals.module';
import {
  MAXIMUM_CHECK_REDEMPTION,
  MAXIMUM_WIRE_REDEMPTION,
  PERSONAL_SERVICES_HIGH_NET_WORTH_NUMBER,
} from '../../../settings/settings';
import Button from '../../Shared/Button/Button';
import If from '../../Shared/If/If';
import TRP from '../../Shared/TRP/TRP';
import { currencyNoPrecision } from '../../../utils/utils';
import { ButtonType } from '../../Shared/Button/types.ts';
import { isAPP, isRAS } from '../../../utils/advice/advice-utility';
import { isAppSell } from '../../../utils/transactions-util';
import styles from '../../Shared/APPText/APPText.module.scss';

const SellFundMinMax = ({
  closeModal,
  selectedSellFundsList,
  ticker,
  productType,
}) => {
  return (
    <div className="sell-fund-min-max-container">
      <h3>Your Daily Minimums & Maximums</h3>
      <p>
        <span className="sell-fund-min-max-emphasize">
          {isRAS(productType) || isAppSell()
            ? 'The minimum amount'
            : 'The minimum distribution amount'}
        </span>{' '}
        {isRAS(productType) || isAppSell() ? (
          <span>
            that may be requested online from an account by ACH or check
            redemption is $1.00, and requests by wire transfer are $100.
          </span>
        ) : (
          <span>
            that can be requested online from
            {productType === 'ManagedAccount' ? ' an account ' : ' a fund '}
            by ACH or check is $1.00
            {productType === 'ManagedAccount'
              ? ''
              : ' or $1.00 worth of shares'}
            , and requests by wire transfer are $100
            {productType === 'ManagedAccount' ? '' : ' or $100 worth of shares'}
            .
          </span>
        )}
      </p>
      <p>
        <span className="sell-fund-min-max-emphasize">Daily maximums</span> are
        determined by two factors:
      </p>
      <ol>
        <li>
          <span className="sell-fund-min-max-emphasize">
            Delivery Method Limit -{' '}
          </span>
          Each delivery method has an associated{' '}
          {isRAS(productType) || isAppSell()
            ? 'maximum redemption amount that you may request online in one day.'
            : 'daily maximum that you can redeem in one day.'}
          <br />
          <span className="sell-fund-min-max-emphasize">&mdash; By Mail: </span>
          {currencyNoPrecision(MAXIMUM_CHECK_REDEMPTION)}.<br />
          <span className="sell-fund-min-max-emphasize">
            &mdash; By Direct Deposit/Wire:{' '}
          </span>
          The maximum redemption amount that may be requested online and sent to
          a bank is {currencyNoPrecision(MAXIMUM_WIRE_REDEMPTION)} combined.
        </li>

        {isRAS(productType) || isAppSell() ? (
          <li>
            <span className="sell-fund-min-max-emphasize">
              Fund Maximum Threshold -{' '}
            </span>
            The current value of your account, which is based on the prior
            market day's closing prices, may be higher or lower than the closing
            market value of your account at the end of the day due to market
            fluctuation. If you submit a redemption request for a dollar amount
            that exceeds the closing market value of your account, your
            transaction will fail and not be executed.
          </li>
        ) : (
          <li>
            <span className="sell-fund-min-max-emphasize">
              {productType === 'ManagedAccount' ? 'Account' : 'Fund'} Maximum
              Threshold -{' '}
            </span>{' '}
            The current value of your fund account, which is based on the prior
            market day's closing prices, may be higher or lower than the closing
            market value of your fund account at the end of the day due to
            market fluctuation. If you submit a redemption request for a dollar
            amount that exceeds the closing market value of your fund account,
            your transaction will fail and not be executed. Avoid this scenario
            by entering a redemption amount as a percentage or number of shares.
          </li>
        )}
      </ol>

      {(isAPP(productType) || isRAS(productType) || isAppSell()) && (
        <div className="sell-fund-min-max-content">
          <span className="sell-fund-min-max-emphasize">
            Minimum Balance Threshold:{' '}
          </span>
          ActivePlus Portfolios<sup className={styles.sup}>®</sup> accounts
          require a minimum of $10,000 to remain in the service. If your
          redemption request would result in your ActivePlus Portfolios
          <sup className={styles.sup}>®</sup> account leaving the account valued
          at less than $10,000, your transaction cannot be executed. To avoid
          this scenario you can select to “Sell all investments & close account”
          but please note that this redemption will close your account.
        </div>
      )}

      <If
        test={
          ticker &&
          selectedSellFundsList &&
          selectedSellFundsList.some(
            (fund) => fund.ticker === ticker && fund.exceededDailyLimit
          )
        }
      >
        <div className="sell-fund-min-max-emphasize">
          To redeem an amount larger than your daily maximum, please call a{' '}
          <TRP /> Associate at{' '}
          <span className="text-nowrap">
            {PERSONAL_SERVICES_HIGH_NET_WORTH_NUMBER}
          </span>
          .
        </div>
      </If>

      <div className="sell-fund-min-max-button-container">
        <Button
          id={`fund-min-max-confirm`}
          buttonType={ButtonType.PRIMARY}
          type="button"
          onClick={() => closeModal(SELL_FUND_MIN_MAX_MODAL)}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default SellFundMinMax;
